export const COUNTRY_COOKIE_NAME = 'coc';
export const SEX_ORIENTATION_COOKIE_NAME = 'sex_version';

export const LAYOUT_TYPES = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};
